import React, { Component } from 'react';
import {DatePicker, Input, TimePicker} from 'antd';
import './AirInput.css';
import classNames from 'classnames';
import LocationAutocomplete from "../Map/LocationAutocomplete";
export default class AirInput extends Component {
  getControl = () => {
    if(this.props.type === 'location') {
      return <LocationAutocomplete
        onSelect={this.props.onSelect}
        onCancelSearch={this.props.onCancelSearch}
        center={this.props.center}
        showExtraIcons={false}
      />
    }

    if(this.props.type === 'date') {
      return <DatePicker
        disabled={this.props.disabled}
        value={this.props.value}
        onChange={this.props.onChange}
        disabledDate={this.props.disabledDate}
        format={this.props.format}
      />
    }

    if(this.props.type === 'time') {
      return <TimePicker
        format='HH:mm'
        disabled={this.props.disabled}
        value={this.props.value}
        onChange={this.props.onChange}
      />
    }

    if(this.props.hasOwnProperty('textarea')) {
      return <Input.TextArea
        disabled={this.props.disabled}
        autosize={this.props.autosize}
        value={this.props.value}
        onChange={this.props.onChange}
        maxLength={this.props.maxlength}
        readOnly={this.props.readOnly}
      />
    }

    return <Input disabled={this.props.disabled} value={this.props.value} onChange={this.props.onChange} maxLength={this.props.maxlength} readOnly={this.props.readOnly} />
  }

  render() {
    const cls = classNames({
      AirInput: true,
      [this.props.className]: !!this.props.className
    });
    return (
      <div className={cls}>
        <div className="label">{this.props.label}</div>
        <div className="control">
          {this.getControl()}
          {!!this.props.maxlength && <div className="maxlength">({this.props.maxlength})</div>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirInput/AirInput.js